import { useEmitUserInteractionEvents as useEmitUserInteractionEventsObservability } from "@zapier/observability";
import { useAtomValue } from "jotai";
import {
  canvasAtom,
  sessionAtom,
  currentAccountIdAtom,
} from "@zapier/canvas-state";

export function useEmitUserInteractionEvents() {
  const canvas = useAtomValue(canvasAtom);
  const session = useAtomValue(sessionAtom);
  const currentAccountId = useAtomValue(currentAccountIdAtom);

  return useEmitUserInteractionEventsObservability({
    canvasId: canvas.id,
    sessionId: session?.id,
    currentAccountId: currentAccountId,
  });
}
